import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import { uploadImage } from "@/lib/api";

export const ImageUploader = ({ value, onChange, label }) => {
  const [loading, setLoading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Bitte eine Bilddatei wählen.");
      return;
    }
    setLoading(true);
    try {
      const res = await uploadImage(file);
      onChange(res.absoluteUrl);
      toast.success("Bild hochgeladen.");
    } catch {
      toast.error("Upload fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2" data-testid={`uploader-${label}`}>
      {value && (
        <img src={value} alt="Vorschau" className="w-full h-40 object-cover border border-gold/30" />
      )}
      <div className="flex items-center gap-3">
        <label className="cursor-pointer inline-flex items-center gap-2 bg-wine text-cream px-4 py-2 text-xs uppercase tracking-[0.15em] hover:bg-wine-dark transition-colors">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
          Bild hochladen
          <input type="file" accept="image/*" className="hidden" onChange={onFile} disabled={loading} />
        </label>
      </div>
      <input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="oder Bild-URL einfügen"
        className="w-full bg-transparent border-b border-wine/20 px-0 py-2 text-sm focus:border-wine focus:outline-none"
      />
    </div>
  );
};
